export const AUTO_CLOSE_DURATION = 5; // seconds
export const NEVER_CLOSE_DURATION = 0; // never
